class ArmourG2Flavor extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bound === 'true') return;
    this.dataset.bound = 'true';
    this.mq = window.matchMedia('(min-width: 750px)');
    this.onReady = this.onReady.bind(this);
    this.setup = this.setup.bind(this);
    if (window.gsap && window.ScrollTrigger) {
      this.onReady();
    } else {
      window.addEventListener('load', this.onReady, { once: true });
    }
    this.mq.addEventListener('change', this.setup);
    document.addEventListener('click', this.onTabClick);
  }

  onTabClick = (event) => {
    if (!event.target.closest('.product-tabs-bar .tabs-bar-item')) return;
    setTimeout(() => {
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    }, 80);
  };

  onReady() {
    if (!window.gsap || !window.ScrollTrigger) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    this.setup();
  }

  resetMobile() {
    const start = this.querySelector('.ag2-flavor__media--start');
    const end = this.querySelector('.ag2-flavor__media--end');
    const startImg = this.querySelector('.ag2-flavor__img-start');
    const panel = this.querySelector('.ag2-flavor__panel');
    const content = this.querySelector('.ag2-flavor__content');
    if (start) {
      start.style.width = '';
      start.style.opacity = '';
    }
    if (startImg) startImg.style.transform = '';
    if (end) end.style.opacity = '';
    if (panel) {
      panel.style.opacity = '1';
      panel.style.visibility = 'visible';
      panel.style.transform = 'none';
    }
    if (content) {
      content.style.opacity = '1';
      content.style.visibility = 'visible';
      content.style.transform = 'none';
    }
  }

  setup() {
    if (this.timeline) {
      this.timeline.scrollTrigger && this.timeline.scrollTrigger.kill();
      this.timeline.kill();
      this.timeline = null;
    }
    const start = this.querySelector('.ag2-flavor__media--start');
    const end = this.querySelector('.ag2-flavor__media--end');
    const startImg = this.querySelector('.ag2-flavor__img-start');
    const panel = this.querySelector('.ag2-flavor__panel');
    const content = this.querySelector('.ag2-flavor__content');
    if (!start || !panel || !content) return;

    if (!this.mq.matches) {
      this.resetMobile();
      return;
    }

    const gsap = window.gsap;
    gsap.set(start, { width: '100%', autoAlpha: 1 });
    if (startImg) gsap.set(startImg, { scale: 1, transformOrigin: '50% 50%' });
    if (end) gsap.set(end, { autoAlpha: 0 });
    gsap.set(panel, { autoAlpha: 0, x: 72 });
    gsap.set(content, { autoAlpha: 0, x: 36 });

    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this,
        start: 'top top',
        end: '+=1400',
        pin: true,
        scrub: 0.8,
        anticipatePin: 1,
      },
    });

    this.timeline.to(panel, { autoAlpha: 1, x: 0, duration: 0.75, ease: 'none' }, 0.08);
    if (startImg) this.timeline.to(startImg, { scale: 1.12, duration: 1, ease: 'none' }, 0);
    if (end) this.timeline.to(end, { autoAlpha: 1, duration: 0.45, ease: 'none' }, 0.35);
    this.timeline.to(content, { autoAlpha: 1, x: 0, duration: 0.55, ease: 'none' }, 0.32);
  }
}

customElements.define('armour-g2-flavor', ArmourG2Flavor);

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-ag2-specs]');
  if (!button) return;
  const tab = document.querySelector('.product-tabs-bar .tabs-bar-item[data-id="specifications"]');
  if (tab) tab.click();
});
